import { queryList, add, update } from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'correctManagement',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *queryList({ payload }, { call, put }) {
      const res = yield call(queryList, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveList',
          payload: res.data,
        });
      }
    },
    *add({ payload }, { call }) {
      return yield call(add, payload);
    },
    *update({ payload }, { call }) {
      return yield call(update, payload);
    },
  },
  reducers: {
    saveList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
